import React from "react"

export default function Current(props){
    
    //identifies wind vector based on API
    const windRose = () => {
        const deg = props.current.windvector;
        if (deg <= 22.5 || deg > 337.5){
            return "N";
        } else if (deg > 22.5 && deg <= 67.5){
            return "NE";
        } else if (deg > 67.5 && deg <= 112.5){
            return "E";
        } else if (deg > 112.5 && deg <= 157.5){
            return "SE";
        } else if (deg > 157.5 && deg <= 202.5){
            return "S";
        } else if (deg > 202.5 && deg <= 247.5){
            return "SW";
        } else if (deg > 247.5 && deg <= 292.5){
            return "W";
        } else if (deg > 292.5 && deg <= 337.5){
            return "NW";
        }
    }

    //sets up current weather data chart
    const tData = [
        {
            title: "Clouds",
            data: `${props.current.clouds}%`,
        },
        {
            title: "Humidity",
            data: `${props.current.humidity}%`,
        },
        {
            title: "Pressure",
            data: `${props.current.pressure} hPa`,
        },
        {
            title: "UV Index",
            data: `${props.current.uvi}`,
        },
        {
            title: "Visibility",
            data: `${props.current.visibility/1000} km`,
        },
        {
            title: "Wind",
            data: `${props.current.windspeed} m/s ${windRose()}`,
        },
    ];
    //adds current weather data to JSX display
    const tableCurrent = () => {
        return(
            tData.map((item, index)=>{
                return(
                    <div key={index} className="table-item">
                        <h3>{item.title}</h3>
                        <h3>{item.data}</h3>
                    </div>
                )
            })
        )
    }

    //set up sunrise/sunset data
    //const sunData = [
    //    {
    //        title: "Sunrise",
    //        data: `${props.current.sunrise}`
    //    },
    //];
    //adds sunrise/sunset data to JSX display
    //const sunCurrent = () => {
    //    return (
    //        sunData.map((item, index) => {
    //            const hour = new Date(item.data*1000).getHours();
    //            const minutes = new Date(item.data*1000).getMinutes();
    //            return(
    //                <div key={index} className="table-item">
    //                    <h3>{item.title}</h3>
    //                    <h3>{hour}:{minutes}</h3>
    //                </div>
    //            )
    //        })
    //    )
    //}


    return (
        <div className="Current-Panel" id="current">
            {tableCurrent()}
        </div>
    )
}